export default {"src":"/_next/static/media/paypal.e7ac00bf.svg","height":8,"width":29,"blurWidth":0,"blurHeight":0};